<template>
    <content-view>
        <div slot="header">
            <a-form :form="form" layout="inline" >
                <a-form-item label="商品编号">
                    <a-input placeholder="请输入" v-decorator="['goodsNo']"></a-input>
                </a-form-item>
                <a-form-item label="商品名称">
                    <a-input placeholder="请输入" v-decorator="['goodsName']"></a-input>
                </a-form-item>
                <a-form-item label="商品分组">
                    <a-select :options="typeOptions" placeholder="请选择" v-decorator="['goodsCategoryId']"></a-select>
                </a-form-item>
                <a-form-item class="wrap-header-button">
                    <a-button type="primary" @click="search" :loading="tableLoading">筛选</a-button>
                    <a-button @click="handleReset" :loading="tableLoading">重置</a-button>
                </a-form-item>
            </a-form>
        </div>
        <div class="trade-record">
            <a-tabs v-model="currentKey" @change="search">
                <a-tab-pane tab="售卖" :key="1"></a-tab-pane>
                <a-tab-pane tab="自用" :key="2"></a-tab-pane>
            </a-tabs>
            <div class="flex">
                <p class="trade-record_title mb8">
                    <a-icon type="info-circle" style="padding-right: 8px;color: #FFBF00;margin-top: 2px;"/>当前仓库 - {{warehouseInfo.warehouseName}}
                </p>
                <a-button v-if="warehouseInfo.warehouseLevel === 1" @click="goBatchAddStorage" type="primary" class="ml16 mb8">批量添加库存</a-button>
                <a-button @click="exportStorage" :loading="exportLoading" type="primary" class="ml16 mb8">导出</a-button>
            </div>
            <a-table
            bordered
            :dataSource="dataSource"
            :columns="columns"
            :pagination="pagination"
            :rowKey="record => record.id"
            :loading="tableLoading"
            @change="changePage"
            class="wrap-table"
            >
                <template slot="action" slot-scope="a,row">
                    <a v-if="warehouseInfo.warehouseLevel === 1" class="text-primary" @click="addBound(row)">添加库存</a>
                    <span v-else>/</span>
                </template>
            </a-table>
        </div>
        <a-modal
        centered
        title="添加库存"
        :width="600"
        :destroyOnClose="true"
        :maskClosable="false"
        :confirmLoading="addBoundLoading"
        v-model="addBoundVisible"
        @ok="addBoundSave"
        >
            <div class="add-bound">
                <a-row>
                    <a-col :span="12"> 商品编号：{{goodsDetail.goodsNo}} </a-col>
                    <a-col :span="12"> 商品名称：{{goodsDetail.goodsName}} </a-col>
                </a-row>
                <a-row>
                    <a-col :span="12"> 商品类型：{{goodsDetail.categoryName}} </a-col>
                    <a-col :span="12"> 商品规格：{{goodsDetail.goodsSpecification}} </a-col>
                </a-row>
                <a-row>
                    <a-col :span="12"> 商品单位：{{goodsDetail.goodsUnit}} </a-col>
                    <a-col :span="12"> 仓库名称：{{warehouseInfo.warehouseName}} </a-col>
                </a-row>
                <a-row>
                    <a-col :span="12"> 当前库存量：{{goodsDetail.currentInventory}} </a-col>
                </a-row>
            </div>
            <div>
                <a-form :form="addBoundForm" layout="inline">
                    <a-form-item label="本次入库数">
                        <a-input-number v-decorator="['num', {rules: [{required: true, message: '请输入'}, {pattern: /^[1-9]{1,}\d*$/, message: '所填值必须为正整数'}]}]" placeholder="请输入"/>
                    </a-form-item>
                </a-form>
            </div>
        </a-modal>
    </content-view>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
import index from '../../utils';
    let columns = [
        {
            title: '商品编号',
            dataIndex: 'goodsNo',
        },
        {
            title: '商品名称',
            dataIndex: 'goodsName'
        },
        {
            title: '商品规格',
            dataIndex: 'goodsSpecification'
        },
        {
            title: '基本单位',
            dataIndex: 'goodsUnit'
        },
        {
            title: '商品分组',
            dataIndex: 'categoryName'
        },
        {
            title: '当前库存量',
            dataIndex: 'currentInventory'
        },
        {
            title: '操作',
            scopedSlots: { customRender: 'action' }
        }];
    export default {
        name: 'storageSave',
        components: {
        },
        props: {},
        data() {
            return {
                currentKey: 1,
                typeOptions: [],
                tableLoading: false,
                warehouseInfo: {},
                columns,
                dataSource: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                addBoundVisible: false,
                addBoundLoading: false,
                goodsDetail: {},
                exportLoading: false,
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        watch: {
            shopId() {
                this.pagination.current = 1;
                this.getGoodsCateList();
                this.getWarehouseInfo();
            }
        },
        methods: {
            // 重置筛选
            handleReset() {
                this.form.resetFields();
                this.search();
            },
            search() {
                this.pagination.current = 1;
                this.warehouseGoodsList();
            },
            //分页回调
            changePage(page) {
                this.pagination = page;
                this.warehouseGoodsList();
            },
            /**
             * @getWarehouseInfo 获取仓库详情
             */
            getWarehouseInfo() {
                let warehouseId = this.$route.params.id;
                this.$api.newStorage.selfWarehouseInfo({
                    query: {
                        id: warehouseId
                    }
                }).then(res => {
                    this.warehouseInfo = res;
                    this.warehouseGoodsList();
                });
            },
            /**
             * @warehouseGoodsList 获取仓库仓储
             */
            warehouseGoodsList() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    let { currentKey, shopId, tableLoading } = this;
                    if (!Boolean(shopId) || tableLoading) {
                        return false;
                    }
                    this.tableLoading = true;
                    this.$api.newStorage.selfWarehouseStoragePage({
                        body: {
                            ...values,
                            shopId,
                            useType: currentKey,
                            warehouseId: this.warehouseInfo.id,
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize
                        }
                    }).then(res => {
                        this.tableLoading = false;
                        if (Boolean(res) && Boolean(res.data)) {
                            this.dataSource = res.data;
                            this.pagination.total = res.total;
                        }
                    }).catch(err => {
                        this.tableLoading = false;
                    });
                })
            },
            /**
             * @addBound 显示添加库存弹出
            */ 
            addBound(row) {
                this.addBoundVisible = true;
                this.goodsDetail = row;
            },
            /**
             * @addBoundSave 单个添加库存
            */ 
            addBoundSave() {
                this.addBoundForm.validateFields((errors, values) => {
                    if (!errors) {
                        this.addBoundLoading = true;
                        this.$api.newStorage.selfGoodsAddNum({
                            body: {
                                goodsId: this.goodsDetail.id,
                                goodsNum: values.num,
                                shopId: this.shopId,
                                userId: this.userInfo.id,
                                account: this.userInfo.account,
                                username: this.userInfo.name
                            }
                        }).then(res => {
                            this.addBoundLoading = false;
                            this.addBoundVisible = false;
                            this.$message.success('操作成功');
                            this.warehouseGoodsList();
                        }).catch(err => {
                            this.addBoundLoading = false;
                        });
                    }
                });
            },
            /**
             * @goBatchAddStorage 跳转批量添加库存
             */
            goBatchAddStorage() {
                this.$router.push({name: 'newBatchStorageSave', params: {warehouseId: this.warehouseInfo.id}});
            },
            /**
             * @exportStorage 库存导出
             */
            exportStorage() {
                this.form.validateFields((errors,values) => {
                    if (errors) return;
                    this.exportLoading = true;
                    let reqData = {
                            ...values,
                            useType: this.currentKey,
                            pageNum: 1,
                            pageSize: 9999999,
                            shopId: this.shopId,
                            warehouseId: this.warehouseInfo.id
                        };
                        this.$api.newStorage.selfWarehouseExport({
                            body: reqData
                        },{
                            responseType: "blob"
                        }).then(res => {
                            this.exportLoading = false;
                            this.exportXlsx(res.data, this.warehouseInfo.warehouseName + `(${['', '售卖', '自用'][this.currentKey]})`);
                            
                        }).catch(err => {
                            this.exportLoading = false;
                        });
                })
            },
            /**
             * @exportXlsx 导出excel
             */
            exportXlsx(data,fileName) {
                let a = document.createElement("a");
                let blob = new Blob([data], {
                    type: "vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                });
                let downloadUrl = window.URL.createObjectURL(blob);
                let name = fileName + '-' + this.$moment().format('YYYY/MM/DD') + '.xlsx'
                a.setAttribute("href", downloadUrl);
                var reportName = decodeURI(name);
                a.setAttribute("download", reportName);
                a.click();
                this.exportLoading = false;
            },
            /**
             * @getGoodsCateList 获取商品分组信息
             */
            getGoodsCateList() {
                if (!this.shopId) {
                    return false;
                }
                this.$api.newStorage.getSelfGoodsCateList({
                    query: {
                        shopId: this.shopId
                    }
                }).then(res => {
                    if (Boolean(res)) {
                        res.forEach(item => {
                            item.label = item.categoryName;
                            item.value = item.id;
                        });
                        this.typeOptions = res;
                    }
                });
            },
        },
        beforeCreate() {
            this.form = this.$form.createForm(this); //筛选表单
            this.addBoundForm = this.$form.createForm(this);
            this.userInfo = this.$userInfoTool.getUser();
        },
        created() {},
        mounted() {
            this.getWarehouseInfo();
            this.getGoodsCateList();
        }
    };
</script>
<style lang="scss">
    .trade-record {
        background-color: #fff;
        padding: 24px 32px;
        border-radius: 2px;
        &_title {
            width: 100%;
            height: 40px;
            background: #fffbe6;
            border: 1px solid #ffe58f;
            border-radius: 4px;
            display: flex;
            align-items: center;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.65);
            padding-left: 16px;
            box-sizing: border-box;
        }
    }
    .add-bound {
        background: rgba(250,250,250,1);
        border-radius: 4px;
        padding: 16px;
        line-height: 34px;
        margin-bottom: 16px;
    }
    .tradeRecord_tab {
        .ant-tabs-ink-bar {
            background-color: #1890ff;
        }
        .ant-tabs-nav .ant-tabs-tab-active {
            color: #1890ff;
        }
    }
</style>